/**
 * Opciones de UI para el Agent Builder (5 capas). Valores estables para persistencia y futuro backend.
 */

export const TRIGGER_KIND_OPTIONS = [
  { value: 'manual', label: 'Manual / prueba' },
  { value: 'event', label: 'Evento de negocio' },
  { value: 'schedule', label: 'Programado (cron)' },
  { value: 'rule', label: 'Regla compuesta' },
];

/** Ejemplos para el campo ref (catálogo futuro) */
export const TRIGGER_REF_PLACEHOLDER =
  'ej. cuota_vence_mañana, atraso_3d, sin_respuesta_48h, promesa_incumplida, comprobante_subido, posible_fraude';

export const ACTION_KIND_OPTIONS = [
  { value: 'whatsapp_template', label: 'Plantilla WhatsApp' },
  { value: 'dynamic_message', label: 'Mensaje dinámico' },
  { value: 'note', label: 'Registrar nota' },
  { value: 'reminder', label: 'Crear recordatorio' },
  { value: 'auto_call', label: 'Llamada automática' },
  { value: 'assign_human', label: 'Asignar a humano' },
  { value: 'block_gestiones', label: 'Bloquear gestiones (tiempo)' },
  { value: 'mark_sensitive', label: 'Marcar cliente sensible' },
  { value: 'request_evidence', label: 'Pedir evidencia' },
];

export const LOGIC_KIND_OPTIONS = [
  { value: 'simple', label: 'Condición simple' },
  { value: 'branch', label: 'Ramas' },
  { value: 'scoring', label: 'Scoring' },
  { value: 'ai_classify', label: 'Clasificación con IA' },
  { value: 'risk_priority', label: 'Prioridad por riesgo' },
];

export const OUTCOME_CATEGORY_OPTIONS = [
  { value: 'response_received', label: 'Respuesta recibida' },
  { value: 'no_response', label: 'Sin respuesta' },
  { value: 'promise_made', label: 'Promesa hecha' },
  { value: 'payment_confirmed', label: 'Pago confirmado' },
  { value: 'invalid_voucher', label: 'Comprobante inválido' },
  { value: 'escalated', label: 'Caso escalado' },
  { value: 'other', label: 'Otro' },
];

function labelFrom(options, value) {
  if (!value) return '';
  return options.find((o) => o.value === value)?.label || value;
}

export const labelForTriggerKind = (v) => labelFrom(TRIGGER_KIND_OPTIONS, v);
export const labelForActionKind = (v) => labelFrom(ACTION_KIND_OPTIONS, v);
export const labelForLogicKind = (v) => labelFrom(LOGIC_KIND_OPTIONS, v);
export const labelForOutcomeCategory = (v) => labelFrom(OUTCOME_CATEGORY_OPTIONS, v);
